import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { UseMutationResult } from "@tanstack/react-query";
import { updateDigestSettings, updateNotificationPreferences } from "../api/notifications-api";
import { NOTIFICATION_TYPES_KEY } from "./useNotificationTypes";
import type {
	DigestSettings,
	NotificationScopeSelection,
	NotificationTypeResource,
	UpdateNotificationPreferencesPayload,
} from "../types/Notifications.type";

export const useSavePreferences = (
	scope: NotificationScopeSelection
): UseMutationResult<NotificationTypeResource[], unknown, UpdateNotificationPreferencesPayload> => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: updateNotificationPreferences,
		onSuccess: (data) => {
			// Save returns the updated types view — set it directly rather than
			// refetching, so the matrix reflects server-authoritative state without
			// a round-trip flash (still never re-derived client-side).
			queryClient.setQueryData(NOTIFICATION_TYPES_KEY.byScope(scope), data);
		},
	});
};

export const useSaveDigestSettings = (): UseMutationResult<DigestSettings, unknown, DigestSettings> => {
	return useMutation({
		mutationFn: updateDigestSettings,
	});
};
